import { useTranslation } from 'react-i18next';

import { IconsLinear } from '@nocowanie/icons/linear';

import { IndicatorButton } from '@app/components/atoms/indicator-button';
import { useMapRedirect } from '@app/hooks/useMapRedirect';

export const MapButton = () => {
    const { t } = useTranslation('listing');
    const handleMapRedirect = useMapRedirect();

    return (
        <IndicatorButton
            onClick={handleMapRedirect}
            icon={<IconsLinear.Location color={'secondary.solid'} w={4} h={4} />}
            aria-label={t('map.buttonLabel')}
        >
            {t('map.buttonLabel')}
        </IndicatorButton>
    );
};
